module.exports = __webpack_public_path__ + "static/media/F2m-loader.ae11e516.svg";